import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AbstractMatchModel = {
  match: ProfileModel;
  matchId: Scalars['String']['output'];
  type: MatchType;
  userId: Scalars['String']['output'];
};

export type AcceptTonightInviteInput = {
  groupId: Scalars['String']['input'];
  /** Relevant when the person is invited to the same group by multiple people. This field is used to identify the inviter. */
  inviterId: Scalars['String']['input'];
};

export type AdminModel = {
  __typename?: 'AdminModel';
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type AegisObservationModel = {
  __typename?: 'AegisObservationModel';
  category: Scalars['String']['output'];
  observations: Array<Array<Scalars['String']['output']>>;
  score: Scalars['Float']['output'];
};

export type AegisReportModel = {
  __typename?: 'AegisReportModel';
  aegisVersion: Scalars['String']['output'];
  blocked: Scalars['Boolean']['output'];
  context: Scalars['String']['output'];
  deviceId: Maybe<Scalars['String']['output']>;
  deviceName: Maybe<Scalars['String']['output']>;
  executionTime: Maybe<Scalars['Float']['output']>;
  headers: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  ipCountry: Maybe<Scalars['String']['output']>;
  observations: Array<AegisObservationModel>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberCountry: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  score: Scalars['Float']['output'];
  stats: Array<Array<Scalars['String']['output']>>;
  usedAt: Maybe<Scalars['DateTime']['output']>;
  userAgent: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type AgeDistributionModel = {
  __typename?: 'AgeDistributionModel';
  age: Scalars['String']['output'];
  count: Scalars['Float']['output'];
};

export type AlbumInfo = {
  __typename?: 'AlbumInfo';
  name: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type AnswerModel = {
  __typename?: 'AnswerModel';
  confessed: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flag: Maybe<Scalars['Boolean']['output']>;
  gameId: Scalars['String']['output'];
  /** Nullable, since sometimes it can just be derived from the accompanying ChatGame instance */
  gameType: Maybe<GameType>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  image: Maybe<ImageModel>;
  late: Scalars['Boolean']['output'];
  player: ProfileModel;
  prompt: Scalars['String']['output'];
  promptEdited: Maybe<Scalars['Boolean']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
  shuffled: Scalars['Float']['output'];
  taggedUser: Maybe<ProfileModel>;
  taggedUserId: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  user: Maybe<ProfileModel>;
  user2: Maybe<ProfileModel>;
  user2Id: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type AppEventModel = {
  __typename?: 'AppEventModel';
  data: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AppInfoModel = {
  __typename?: 'AppInfoModel';
  date: Scalars['DateTime']['output'];
  enforcedAppVersion: Maybe<Scalars['String']['output']>;
  environment: Maybe<Scalars['String']['output']>;
  latestAppVersion: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
};

export type AreaPopulationModel = {
  __typename?: 'AreaPopulationModel';
  female: Scalars['Float']['output'];
  male: Scalars['Float']['output'];
  nonBinary: Scalars['Float']['output'];
  waitlist: Scalars['Float']['output'];
};

export type AuditlogModel = {
  __typename?: 'AuditlogModel';
  callerId: Scalars['String']['output'];
  callerName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  exception: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  input: Scalars['JSON']['output'];
  operation: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  output: Scalars['JSON']['output'];
  resourceType: Scalars['String']['output'];
};

export type AuthTokensModel = {
  __typename?: 'AuthTokensModel';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AutoCompleteAddressInput = {
  city: InputMaybe<Scalars['String']['input']>;
  countryCodeISO3: InputMaybe<Scalars['String']['input']>;
  formatted: InputMaybe<Scalars['String']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  neighborhood: InputMaybe<Scalars['String']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  streetName: InputMaybe<Scalars['String']['input']>;
  streetNumber: InputMaybe<Scalars['String']['input']>;
};

export type AutoCompleteAddressModel = {
  __typename?: 'AutoCompleteAddressModel';
  city: Scalars['String']['output'];
  countryCodeISO3: Scalars['String']['output'];
  formatted: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  neighborhood: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  streetName: Maybe<Scalars['String']['output']>;
  streetNumber: Maybe<Scalars['String']['output']>;
};

export type BoostModel = {
  __typename?: 'BoostModel';
  createdAt: Scalars['DateTime']['output'];
  endsAt: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  issuerUserId: Scalars['String']['output'];
  jwtToken: Maybe<Scalars['String']['output']>;
  pairedBoost: Maybe<BoostModel>;
  profile: ProfileModel;
  trigger: ConsumableItemTrigger;
  triggerId: Scalars['String']['output'];
  type: ConsumableItemType;
  used: Scalars['Boolean']['output'];
  usedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type CanChangeProfileFieldArg = {
  field: RestrictedProfileField;
};

export type CandidateMetaData = {
  __typename?: 'CandidateMetaData';
  /** @deprecated We now use DrDre canary instances, see dreVariant */
  appliedAlgorithm: Maybe<Scalars['Float']['output']>;
  appliedDreVariant: Maybe<Scalars['String']['output']>;
  appliedFilter: Maybe<Filter>;
};

export type CandidateModel = {
  __typename?: 'CandidateModel';
  category: Maybe<Scalars['Float']['output']>;
  mapType: Maybe<Scalars['Float']['output']>;
  metaData: Maybe<CandidateMetaData>;
  potentialDoubbleMatchWith: Maybe<ProfileModel>;
  potentialDoubbleMatchWithMatchUserId: Maybe<Scalars['String']['output']>;
  potentialDoubbleMatchWithUserId: Maybe<Scalars['String']['output']>;
  potentialDoubbleMatchWithUserRegion: Maybe<Scalars['String']['output']>;
  preferenceScore: Maybe<Scalars['Float']['output']>;
  profile: Maybe<ProfileModel>;
  recommendedBy: Maybe<ProfileModel>;
  sharedBy: Maybe<ProfileModel>;
  sharedById: Maybe<Scalars['String']['output']>;
  sharedByRegion: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRegion: Scalars['String']['output'];
};

export type CandidateStatsInput = {
  candidateUserId: InputMaybe<Scalars['String']['input']>;
  data: InputMaybe<Scalars['JSON']['input']>;
  firstImageId: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  imagesCount: InputMaybe<Scalars['Float']['input']>;
  imagesSeen: InputMaybe<Scalars['Float']['input']>;
  imagesSwiped: InputMaybe<Scalars['Float']['input']>;
  lastSeenImageId: InputMaybe<Scalars['String']['input']>;
  like: InputMaybe<Scalars['Boolean']['input']>;
  longestSeenImageId: InputMaybe<Scalars['String']['input']>;
  longestSeenImageSeconds: InputMaybe<Scalars['Float']['input']>;
  mapCategory: InputMaybe<Scalars['Float']['input']>;
  mapType: InputMaybe<Scalars['Float']['input']>;
  mostSeenImageId: InputMaybe<Scalars['String']['input']>;
  preferenceScore: InputMaybe<Scalars['Float']['input']>;
  secondsSeen: InputMaybe<Scalars['Float']['input']>;
  type: InputMaybe<CandidateStatsType>;
  undos: InputMaybe<Scalars['Float']['input']>;
};

export type CellModel = {
  __typename?: 'CellModel';
  base: Scalars['Float']['output'];
  cell: Scalars['String']['output'];
  region: Region;
};

export type ChatGameModel = {
  __typename?: 'ChatGameModel';
  answers: Array<AnswerModel>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<ProfileModel>;
  id: Scalars['ID']['output'];
  originalPrompt: Maybe<PromptModel>;
  prompt: Scalars['String']['output'];
  promptEdited: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  type: GameType;
};

export type ChatModel = {
  __typename?: 'ChatModel';
  createdAt: Scalars['DateTime']['output'];
  doubbleMatch: Maybe<DoubbleMatchModel>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Uses messages() when querying. It's important that messages is the first field in the query as the take parameter in messages() is otherwise not respected */
  isSeen: Scalars['Boolean']['output'];
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  latestGameAnswerAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use messages field instead */
  latestMessage: Maybe<MessageModel>;
  locked: Scalars['Boolean']['output'];
  /** @deprecated Use users instead */
  matchUsers: Array<ChatUserModel>;
  messages: Maybe<Array<MessageModel>>;
  region: Region;
  tonightChatContext: Maybe<TonightChatContextModel>;
  /** For TONIGHT_CHAT types, this field extracts the original typeId and returns the two group ids it comprises */
  tonightGroupIds: Maybe<Array<Scalars['String']['output']>>;
  type: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
  users: Array<ChatUserModel>;
};


export type ChatModelMessagesArgs = {
  take: InputMaybe<Scalars['Float']['input']>;
};

export type ChatSeenEventModel = {
  __typename?: 'ChatSeenEventModel';
  seenAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ChatStreamEventModel = {
  __typename?: 'ChatStreamEventModel';
  chatId: Scalars['String']['output'];
  chatSeen: Maybe<ChatSeenEventModel>;
  isUpdate: Scalars['Boolean']['output'];
  message: Maybe<MessageModel>;
  reaction: Maybe<MessageReactionModel>;
  swipedProfileAttachment: Maybe<SwipedProfileAttachmentModel>;
  userStoppedTyping: Maybe<Scalars['String']['output']>;
  userTyping: Maybe<Scalars['String']['output']>;
};

export enum ChatType {
  CHAT = 'CHAT',
  CONTACT_CHAT = 'CONTACT_CHAT',
  DOUBBLE_MATCH_CHAT = 'DOUBBLE_MATCH_CHAT',
  MATCH_CHAT = 'MATCH_CHAT',
  PRE_USER_CHAT = 'PRE_USER_CHAT',
  TONIGHT_CHAT = 'TONIGHT_CHAT',
  TONIGHT_GROUP_CHAT = 'TONIGHT_GROUP_CHAT'
}

export type ChatUserModel = {
  __typename?: 'ChatUserModel';
  /** @deprecated Use profile.images instead */
  avatar: Scalars['String']['output'];
  causedByBoost: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use profile.name instead */
  displayName: Scalars['String']['output'];
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  profile: ProfileModel;
  /** @deprecated Use profile.id instead */
  profileId: Scalars['ID']['output'];
  relationship: Scalars['String']['output'];
  status: Maybe<ChatUserStatus>;
};

export type ComplimentModel = {
  __typename?: 'ComplimentModel';
  emoji: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: Maybe<ComplimentType>;
};

export type ConsumableItemModel = {
  __typename?: 'ConsumableItemModel';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  issuerUserId: Scalars['String']['output'];
  trigger: ConsumableItemTrigger;
  triggerId: Scalars['String']['output'];
  type: ConsumableItemType;
  usedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type ContactInviteProfileModel = {
  __typename?: 'ContactInviteProfileModel';
  gender: Maybe<Scalars['String']['output']>;
  imageThumbnailUrl: Maybe<Scalars['String']['output']>;
  language: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type CreatePlaceInput = {
  address: AutoCompleteAddressInput;
  base64Image: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};

export type DatingProfileInfoInput = {
  algorithm: InputMaybe<Scalars['Float']['input']>;
  bio: InputMaybe<Scalars['String']['input']>;
  birthDate: InputMaybe<Scalars['DateTime']['input']>;
  city: InputMaybe<AutoCompleteAddressInput>;
  compliments: InputMaybe<Array<Scalars['String']['input']>>;
  email: InputMaybe<Scalars['String']['input']>;
  gender: InputMaybe<Gender>;
  height: InputMaybe<Scalars['Int']['input']>;
  inboxPreference: InputMaybe<InboxPreference>;
  incognito: InputMaybe<Scalars['Boolean']['input']>;
  interests: InputMaybe<Array<Scalars['String']['input']>>;
  language: InputMaybe<Locales>;
  matchingActive: InputMaybe<Scalars['Boolean']['input']>;
  maxSuggestionAge: InputMaybe<Scalars['Int']['input']>;
  maxSuggestionDistance: InputMaybe<Scalars['Float']['input']>;
  minSuggestionAge: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  occupation: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  profileImageUrls: InputMaybe<Array<Scalars['String']['input']>>;
  public: InputMaybe<Scalars['Boolean']['input']>;
  school: InputMaybe<Scalars['String']['input']>;
  sexualOrientations: InputMaybe<Array<Gender>>;
  strictAgeRange: InputMaybe<Scalars['Boolean']['input']>;
  strictDistance: InputMaybe<Scalars['Boolean']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};

export type DeleteProfileInput = {
  delayed: Scalars['Boolean']['input'];
  profileId: Scalars['String']['input'];
};

export type DoubbleMatchDistributionModel = {
  __typename?: 'DoubbleMatchDistributionModel';
  count: Scalars['Float']['output'];
  doubbleMatches: Scalars['Float']['output'];
};

export type DoubbleMatchModel = AbstractMatchModel & {
  __typename?: 'DoubbleMatchModel';
  /** @deprecated Use chat.createdAt instead */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  doubbleChatId: Scalars['String']['output'];
  expireAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isSeen: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  latestMessageAt: Maybe<Scalars['DateTime']['output']>;
  match: ProfileModel;
  matchId: Scalars['String']['output'];
  matchTeamMateId: Scalars['String']['output'];
  teamMateId: Scalars['String']['output'];
  type: MatchType;
  userId: Scalars['String']['output'];
  users: Array<ChatUserModel>;
};

export type EditPlaceInput = {
  address: InputMaybe<AutoCompleteAddressInput>;
  base64Image: InputMaybe<Scalars['String']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};

export type ExpiringDoubbleMatchesModel = {
  __typename?: 'ExpiringDoubbleMatchesModel';
  count: Scalars['Float']['output'];
  image: Maybe<ImageModel>;
};

export enum FeedbackType {
  DEACTIVATED_PROFILE = 'DEACTIVATED_PROFILE',
  DELETING_PROFILE = 'DELETING_PROFILE',
  FEEDBACK = 'FEEDBACK'
}

export type FriendSuggestionModel = {
  __typename?: 'FriendSuggestionModel';
  category: FriendSuggestionsCategory;
  contact: Maybe<PhoneNumberInviteModel>;
  profile: Maybe<ProfileModel>;
};

export enum GameType {
  CAMERA_NOW = 'CAMERA_NOW',
  FREE_TEXT = 'FREE_TEXT',
  HOT_TAKE = 'HOT_TAKE',
  MOST_LIKELY_TO = 'MOST_LIKELY_TO',
  NEVER_HAVE_I_EVER = 'NEVER_HAVE_I_EVER',
  PHOTO_CHALLENGE = 'PHOTO_CHALLENGE',
  RED_FLAG_GREEN_FLAG = 'RED_FLAG_GREEN_FLAG',
  ROULETTE = 'ROULETTE',
  VOICE_CHALLENGE = 'VOICE_CHALLENGE',
  WHO_IS_WHO = 'WHO_IS_WHO'
}

export type GenderDistributionModel = {
  __typename?: 'GenderDistributionModel';
  count: Scalars['Float']['output'];
  gender: Scalars['String']['output'];
};

export type GetSuspensionsInput = {
  phoneNumber: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ImageModel = {
  __typename?: 'ImageModel';
  blurhash: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['String']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  /** The querying user's reaaction to the image */
  myReaction: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Float']['output']>;
  reactionSummary: Maybe<ProfileReactionSummary>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** @deprecated use blurhash instead */
  tinyUrl: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type InstagramMediaModel = {
  __typename?: 'InstagramMediaModel';
  caption: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Only available for reels */
  isSharedToFeed: Maybe<Scalars['Boolean']['output']>;
  mediaType: Scalars['String']['output'];
  mediaUrl: Scalars['String']['output'];
  permalink: Scalars['String']['output'];
  /** Only available for videos */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type InterestModel = {
  __typename?: 'InterestModel';
  category: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InviteCodeModel = {
  __typename?: 'InviteCodeModel';
  autoInvite: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  isUnlock: Scalars['Boolean']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type InviteModel = {
  __typename?: 'InviteModel';
  autoInvite: Scalars['Boolean']['output'];
  friends: Array<ContactInviteProfileModel>;
  inviteCode: Maybe<Scalars['String']['output']>;
  match: Maybe<ContactInviteProfileModel>;
  profile: ContactInviteProfileModel;
};

export type InviteToTonightGroupInput = {
  groupId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type InvitesDataModel = {
  __typename?: 'InvitesDataModel';
  count: Scalars['Float']['output'];
  lastReceivedAt: Maybe<Scalars['DateTime']['output']>;
};

export type LikedMeModel = {
  __typename?: 'LikedMeModel';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDisliked: Scalars['Boolean']['output'];
  profile: ProfileModel;
};

export type LikesAndDislikesModel = {
  __typename?: 'LikesAndDislikesModel';
  dislikes: Scalars['Float']['output'];
  likeToDislikeRatio: Scalars['Float']['output'];
  likes: Scalars['Float']['output'];
};

export type LocationModel = {
  __typename?: 'LocationModel';
  cells: CellModel;
  countryCode: Maybe<Scalars['String']['output']>;
  didChangeRegion: Scalars['Boolean']['output'];
  /** Distance moved in kilometers */
  distanceMoved: Maybe<Scalars['Float']['output']>;
  jwtToken: Maybe<Scalars['String']['output']>;
  location: PointModel;
  onWaitlist: Maybe<Scalars['Boolean']['output']>;
  withinSupportedRegion: Maybe<Scalars['Boolean']['output']>;
};

export type LogoutInput = {
  refreshToken: Scalars['String']['input'];
};

export type MatchModel = AbstractMatchModel & {
  __typename?: 'MatchModel';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  match: ProfileModel;
  matchId: Scalars['String']['output'];
  type: MatchType;
  userId: Scalars['String']['output'];
};

export type MatchesFilterInput = {
  matchId: InputMaybe<Scalars['String']['input']>;
  spacetime: InputMaybe<SpacetimeFilter>;
  teamMateId: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<MatchType>;
};

export type MatchesGroupByInput = {
  match: Scalars['Boolean']['input'];
};

export type MessageAttachmentModel = {
  __typename?: 'MessageAttachmentModel';
  data: Scalars['String']['output'];
  /** Specifically to resolve GAME_ANSWER_REPLY attachments, since these need translation and "HIDDEN" status */
  gameAnswer: Maybe<AnswerModel>;
  id: Scalars['ID']['output'];
  kind: MessageAttachmentKind;
  userId: Maybe<Scalars['String']['output']>;
};

export type MessageModel = {
  __typename?: 'MessageModel';
  attachments: Array<MessageAttachmentModel>;
  chat: ChatModel;
  chatId: Maybe<Scalars['String']['output']>;
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  gameAnswer: Maybe<AnswerModel>;
  id: Scalars['ID']['output'];
  sender: ChatUserModel;
  senderId: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type MessageReactionModel = {
  __typename?: 'MessageReactionModel';
  emoji: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptChatRequest: Scalars['Boolean']['output'];
  acceptGiftedBoostInvitation: BoostModel;
  addNotificationToken: Scalars['Boolean']['output'];
  adminDeleteAccount: Scalars['Boolean']['output'];
  adminRemoveProfileImage: Scalars['Boolean']['output'];
  /** Ask a reporter for elaboration on a report */
  askForElaboration: Scalars['Boolean']['output'];
  authenticateInstagram: Scalars['Boolean']['output'];
  cancelAccountDeletion: Scalars['Boolean']['output'];
  cancelInvite: Scalars['Boolean']['output'];
  changeNotificationsOptions: Array<NotificationOptionModel>;
  changeNumber: Scalars['String']['output'];
  /** Deletes all reports given to a specific profile */
  clearReportsOnUser: Scalars['Boolean']['output'];
  consumeMatchChatUnlock: Scalars['Boolean']['output'];
  /** @deprecated Use createProfile instead */
  createDatingProfile: ProfileModel;
  createInviteCode: InviteCodeModel;
  createPlace: PlaceModel;
  createProfile: ProfileModel;
  createTonightGroup: TonightGroupModel;
  createTonightInviteCode: Scalars['String']['output'];
  /** Creates a warning for a specific profile */
  createWarning: Scalars['Boolean']['output'];
  /** @deprecated Use deleteAccountV2 instead */
  deleteAccount: Scalars['Boolean']['output'];
  deleteAccountV2: Scalars['Boolean']['output'];
  deletePlace: PlaceModel;
  deletePlaceSuggestions: Scalars['Boolean']['output'];
  disableNotificationToken: Scalars['Boolean']['output'];
  /** @deprecated Use swipe instead. */
  dislike: Scalars['Boolean']['output'];
  dismissContactChat: Scalars['Boolean']['output'];
  /** @deprecated Use editProfile instead */
  editDatingProfile: ProfileModel;
  editPlace: PlaceModel;
  editProfile: ProfileModel;
  editUser: UserModel;
  /** Enables paywall for user */
  enablePaywall: Scalars['Boolean']['output'];
  /** Evicts a member from a tonight group. You need to be admin/group creator to perform this action */
  evictFromTonightGroup: Scalars['Boolean']['output'];
  fakeCompletedPhotoTest: PhotoTestModel;
  fakeCompliment: Scalars['Boolean']['output'];
  fakeConversation: Scalars['Boolean']['output'];
  fakeDoubbleMatch: Scalars['Boolean']['output'];
  fakeInvite: Scalars['Boolean']['output'];
  fakeMatch: Scalars['Boolean']['output'];
  fakeMatchBetweenSwipers: Scalars['Boolean']['output'];
  fakeMatchWithId: Scalars['Boolean']['output'];
  fakeNewUserNotification: Scalars['Boolean']['output'];
  fakePhotoTest: PhotoTestModel;
  fakeQueue: Scalars['Boolean']['output'];
  fakeRandomCandidateStats: Scalars['String']['output'];
  fakeReaction: Scalars['Boolean']['output'];
  getInvitedToTonightGroup: Scalars['Boolean']['output'];
  getSuspensions: Scalars['Boolean']['output'];
  /** Creates or retrieves the TONIGHT_CHAT between two tonight groups */
  getTonightChat: ChatModel;
  grantConsumable: Scalars['Boolean']['output'];
  /** @deprecated Might be relevant for client-only invite actions (e.g. Snap) in the future. TODO: Remove after 01-05-2023 if not used. */
  grantUnlimitedLikes: Scalars['Boolean']['output'];
  handleLoginLinkToken: AuthTokensModel;
  ignoreChatRequest: Scalars['Boolean']['output'];
  ignoreContact: Scalars['Boolean']['output'];
  ignoreTeammateSuggestion: Scalars['Boolean']['output'];
  inviteContact: PhoneNumberInviteModel;
  inviteFriendToBoost: BoostModel;
  inviteProfile: Scalars['Boolean']['output'];
  /** @deprecated use inviteProfile instead */
  inviteProfileV2: Scalars['Boolean']['output'];
  inviteToTonightGroup: TonightGroupModel;
  isTyping: Scalars['Boolean']['output'];
  /** Leaves the TONIGHT_CHAT, that is, the chat between two tonight groups */
  leaveTonightChat: Scalars['Boolean']['output'];
  /** Leaves the TONIGHT_GROUP_CHAT, that is, the chat created for a given tonight group */
  leaveTonightGroup: Scalars['Boolean']['output'];
  /** @deprecated Use swipe instead */
  like: SwipeModel;
  likeCompliment: Scalars['Boolean']['output'];
  login: AuthTokensModel;
  /** @deprecated Use login instead */
  loginV2: AuthTokensModel;
  logout: Scalars['Boolean']['output'];
  markWarningsAsSeen: Scalars['Boolean']['output'];
  matchJoinTonightGroup: Scalars['Boolean']['output'];
  messageSeen: Scalars['DateTime']['output'];
  muteChat: Scalars['Boolean']['output'];
  openedTonightNotification: Scalars['Boolean']['output'];
  openedTonightScreen: Scalars['Boolean']['output'];
  pingToAddFriends: Scalars['Boolean']['output'];
  playChatGame: Scalars['Boolean']['output'];
  populateProfileCache: Scalars['Boolean']['output'];
  reactToMessage: Scalars['Boolean']['output'];
  reactToProfileImage: Scalars['Boolean']['output'];
  recommendPlace: MessageModel;
  refreshAuthTokens: AuthTokensModel;
  /** @deprecated Use refreshAuthTokens instead */
  refreshAuthTokensV2: AuthTokensModel;
  removeImageFromProfile: Scalars['Boolean']['output'];
  removeTeammate: Scalars['Boolean']['output'];
  /** Removes name/gender limit */
  removeUpdateLimit: Scalars['Boolean']['output'];
  replyToCompliment: Scalars['Boolean']['output'];
  replyToGame: MessageModel;
  /** @deprecated Use replyToGameAnswerV2 */
  replyToGameAnswer: MessageModel;
  replyToGameAnswerV2: MessageModel;
  reportContent: Scalars['Boolean']['output'];
  requestEmailLogin: Scalars['Boolean']['output'];
  requestLoginV2: OtpRequestModel;
  requestNumberChange: OtpRequestModel;
  requestUserCreation: OtpRequestModel;
  respondToInvite: Maybe<ProfileModel>;
  /** Accepts an invitation to join a TONIGHT_GROUP */
  respondToTonightGroupInvite: Scalars['Boolean']['output'];
  revealPhotoTest: PhotoTestModel;
  revokeSuspension: Scalars['Boolean']['output'];
  saveCandidateStats: Scalars['String']['output'];
  saveDeviceInfo: Scalars['Boolean']['output'];
  saveProfileContacts: Scalars['Boolean']['output'];
  savePrompt: PromptModel;
  saveRedisConfig: Scalars['Boolean']['output'];
  seenCompliment: Scalars['Boolean']['output'];
  seenNotification: Scalars['Boolean']['output'];
  sendCompliment: ProfileComplimentModel;
  sendFeedback: Scalars['Boolean']['output'];
  sendGif: MessageModel;
  sendMessage: MessageModel;
  /** @deprecated Use sendMessage instead */
  sendMessageV2: MessageModel;
  setDeepLinkRemotely: Scalars['Float']['output'];
  setLocation: LocationModel;
  setMatchingStatus: Scalars['Boolean']['output'];
  setSuspension: SuspensionModel;
  shareProfile: Array<MessageModel>;
  skipCompliment: Scalars['Boolean']['output'];
  startBoost: BoostModel;
  startChatGame: ChatGameModel;
  startPhotoTest: PhotoTestModel;
  stoppedTyping: Scalars['Boolean']['output'];
  submitAnswer: AnswerModel;
  submitSingleAnswerGames: Array<AnswerModel>;
  subscribeToTonight: Scalars['Boolean']['output'];
  suggestPlace: Scalars['Boolean']['output'];
  swipe: SwipeModel;
  swipedSharedProfile: Scalars['Boolean']['output'];
  testNotification: TestNotificationModel;
  testNotificationToken: Scalars['Boolean']['output'];
  undoLikeOrDislike: Scalars['Boolean']['output'];
  unlockChat: Scalars['Boolean']['output'];
  unmatch: Scalars['Boolean']['output'];
  unmatchDoubbleMatch: Scalars['Boolean']['output'];
  unsubscribeFromTonight: Scalars['Boolean']['output'];
  updateActivity: Scalars['Boolean']['output'];
  updateCandidateStats: Scalars['Boolean']['output'];
  /** Updates wait list status */
  updateWaitListStatus: Scalars['Boolean']['output'];
  /** @deprecated We no longer use deep links, and thus many args are no longer relevant to maintain. Use verifyAndCreateUserV2 instead. */
  verifyAndCreateUser: AuthTokensModel;
  verifyAndCreateUserV2: AuthTokensModel;
  waitingList: Scalars['Boolean']['output'];
  whitelistPhoneNumber: Scalars['Boolean']['output'];
  withinSupportedRegion: Scalars['Boolean']['output'];
};


export type MutationAcceptChatRequestArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationAcceptGiftedBoostInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddNotificationTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationAdminDeleteAccountArgs = {
  deleteInput: DeleteProfileInput;
};


export type MutationAdminRemoveProfileImageArgs = {
  imageUrl: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAskForElaborationArgs = {
  reportId: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthenticateInstagramArgs = {
  code: Scalars['String']['input'];
};


export type MutationCancelInviteArgs = {
  invitedId: Scalars['String']['input'];
};


export type MutationChangeNotificationsOptionsArgs = {
  notificationOptions: Array<NotificationOptionInput>;
  token: Scalars['String']['input'];
};


export type MutationChangeNumberArgs = {
  id: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationClearReportsOnUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationConsumeMatchChatUnlockArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationCreateDatingProfileArgs = {
  email: Scalars['String']['input'];
  info: DatingProfileInfoInput;
  username: Scalars['String']['input'];
};


export type MutationCreateInviteCodeArgs = {
  autoInvite: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  sharedProfileId: InputMaybe<Scalars['String']['input']>;
  unlockMatchId: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePlaceArgs = {
  createPlaceInput: CreatePlaceInput;
};


export type MutationCreateProfileArgs = {
  email: Scalars['String']['input'];
  info: ProfileInfoInput;
  username: Scalars['String']['input'];
};


export type MutationCreateTonightInviteCodeArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationCreateWarningArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  feedback: InputMaybe<UserFeedbackInput>;
};


export type MutationDeleteAccountV2Args = {
  feedback: InputMaybe<UserFeedbackInput>;
};


export type MutationDeletePlaceArgs = {
  placeId: Scalars['String']['input'];
};


export type MutationDeletePlaceSuggestionsArgs = {
  suggestionIds?: Array<Scalars['String']['input']>;
};


export type MutationDisableNotificationTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationDislikeArgs = {
  category: InputMaybe<Scalars['Float']['input']>;
  profileId: Scalars['String']['input'];
};


export type MutationDismissContactChatArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationEditDatingProfileArgs = {
  info: DatingProfileInfoInput;
};


export type MutationEditPlaceArgs = {
  input: EditPlaceInput;
};


export type MutationEditProfileArgs = {
  info: ProfileInfoInput;
};


export type MutationEditUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<Locales>;
  phone: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnablePaywallArgs = {
  userId: Scalars['String']['input'];
};


export type MutationEvictFromTonightGroupArgs = {
  evictId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};


export type MutationFakeCompletedPhotoTestArgs = {
  revealed: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFakeComplimentArgs = {
  complimentId: InputMaybe<Scalars['String']['input']>;
  fromFriend: InputMaybe<Scalars['Boolean']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type MutationFakeConversationArgs = {
  amountOfMessages: Scalars['Float']['input'];
  chatId: InputMaybe<Scalars['String']['input']>;
  chatType: Scalars['String']['input'];
  typeId: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type MutationFakeInviteArgs = {
  username: InputMaybe<Scalars['String']['input']>;
};


export type MutationFakeMatchBetweenSwipersArgs = {
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
};


export type MutationFakeMatchWithIdArgs = {
  matchId: Scalars['String']['input'];
};


export type MutationFakeReactionArgs = {
  reaction: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetInvitedToTonightGroupArgs = {
  maxMembers: InputMaybe<Scalars['Float']['input']>;
};


export type MutationGetSuspensionsArgs = {
  query: GetSuspensionsInput;
};


export type MutationGetTonightChatArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationGrantConsumableArgs = {
  expiresAt: InputMaybe<Scalars['String']['input']>;
  type: ConsumableItemType;
};


export type MutationHandleLoginLinkTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationIgnoreChatRequestArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationIgnoreContactArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationIgnoreTeammateSuggestionArgs = {
  profileToIgnore: Scalars['String']['input'];
};


export type MutationInviteContactArgs = {
  inviteCode: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationInviteFriendToBoostArgs = {
  friendId: Scalars['String']['input'];
};


export type MutationInviteProfileArgs = {
  id: Scalars['String']['input'];
};


export type MutationInviteProfileV2Args = {
  username: Scalars['String']['input'];
};


export type MutationInviteToTonightGroupArgs = {
  input: InviteToTonightGroupInput;
};


export type MutationIsTypingArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationLeaveTonightChatArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationLeaveTonightGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationLikeArgs = {
  category: InputMaybe<Scalars['Float']['input']>;
  profileId: Scalars['String']['input'];
};


export type MutationLikeComplimentArgs = {
  complimentId: Scalars['String']['input'];
  complimenterUserId: Scalars['String']['input'];
  like: Scalars['Boolean']['input'];
};


export type MutationLoginArgs = {
  id: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationLoginV2Args = {
  id: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  logoutInput: LogoutInput;
};


export type MutationMessageSeenArgs = {
  chatId: InputMaybe<Scalars['String']['input']>;
};


export type MutationMuteChatArgs = {
  chatId: Scalars['String']['input'];
  until: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationPingToAddFriendsArgs = {
  userId: Scalars['String']['input'];
};


export type MutationPlayChatGameArgs = {
  chatId: Scalars['String']['input'];
  customPrompt: InputMaybe<Scalars['String']['input']>;
};


export type MutationReactToMessageArgs = {
  chatId: Scalars['String']['input'];
  emoji: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
};


export type MutationReactToProfileImageArgs = {
  input: ProfileImageReactionInput;
};


export type MutationRecommendPlaceArgs = {
  chatId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};


export type MutationRefreshAuthTokensArgs = {
  refreshAuthTokensInput: RefreshAuthTokensInput;
};


export type MutationRefreshAuthTokensV2Args = {
  refreshAuthTokensInput: RefreshAuthTokensInput;
};


export type MutationRemoveImageFromProfileArgs = {
  imageUrl: Scalars['String']['input'];
};


export type MutationRemoveTeammateArgs = {
  teammateId: Scalars['String']['input'];
};


export type MutationRemoveUpdateLimitArgs = {
  userId: Scalars['String']['input'];
};


export type MutationReplyToComplimentArgs = {
  complimentId: Scalars['String']['input'];
  complimenterUserId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationReplyToGameArgs = {
  input: ReplyToGameInput;
};


export type MutationReplyToGameAnswerArgs = {
  input: ReplyToGameAnswerInput;
};


export type MutationReplyToGameAnswerV2Args = {
  input: ReplyToGameAnswerInputV2;
};


export type MutationReportContentArgs = {
  report: ReportInput;
};


export type MutationRequestEmailLoginArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestLoginV2Args = {
  isRetry?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationRequestNumberChangeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationRequestUserCreationArgs = {
  isRetry?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationRespondToInviteArgs = {
  inviterId: Scalars['String']['input'];
  response: InviteResponse;
};


export type MutationRespondToTonightGroupInviteArgs = {
  input: AcceptTonightInviteInput;
};


export type MutationRevealPhotoTestArgs = {
  photoTestId: Scalars['String']['input'];
};


export type MutationRevokeSuspensionArgs = {
  revokeInput: RevokeSuspensionInput;
};


export type MutationSaveCandidateStatsArgs = {
  input: CandidateStatsInput;
};


export type MutationSaveDeviceInfoArgs = {
  input: SaveDeviceInfoArgs;
};


export type MutationSaveProfileContactsArgs = {
  contactInformationInputs?: Array<ProfileContactInformationInput>;
};


export type MutationSavePromptArgs = {
  input: SavePromptInput;
};


export type MutationSaveRedisConfigArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationSeenComplimentArgs = {
  complimentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSeenNotificationArgs = {
  id: Scalars['String']['input'];
  opened?: Scalars['Boolean']['input'];
};


export type MutationSendComplimentArgs = {
  complimentId: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  pollUsers: Array<PollUserData>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendFeedbackArgs = {
  feedback: InputMaybe<UserFeedbackInput>;
};


export type MutationSendGifArgs = {
  chatId: Scalars['String']['input'];
  giphyId: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendMessageV2Args = {
  input: SendMessageInput;
};


export type MutationSetDeepLinkRemotelyArgs = {
  link: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetLocationArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type MutationSetMatchingStatusArgs = {
  status: Scalars['Boolean']['input'];
};


export type MutationSetSuspensionArgs = {
  suspensionInput: SuspensionInput;
};


export type MutationShareProfileArgs = {
  input: ShareProfileInput;
};


export type MutationSkipComplimentArgs = {
  complimentId: Scalars['String']['input'];
};


export type MutationStartBoostArgs = {
  friendId: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartChatGameArgs = {
  input: StartChatGameInput;
};


export type MutationStartPhotoTestArgs = {
  input: StartPhotoTestInput;
};


export type MutationStoppedTypingArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationSubmitAnswerArgs = {
  input: SubmitAnswerInput;
};


export type MutationSubmitSingleAnswerGamesArgs = {
  input: SubmitSingleAnswersInput;
};


export type MutationSuggestPlaceArgs = {
  suggestion: PlaceSuggestionInput;
};


export type MutationSwipeArgs = {
  category: Scalars['Float']['input'];
  like: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSwipedSharedProfileArgs = {
  chatId: Scalars['String']['input'];
  liked: Scalars['Boolean']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationTestNotificationArgs = {
  data: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationTestNotificationTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUndoLikeOrDislikeArgs = {
  swipedId: Scalars['String']['input'];
};


export type MutationUnlockChatArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationUnmatchArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUnmatchDoubbleMatchArgs = {
  doubbleMatchId: Scalars['String']['input'];
};


export type MutationUpdateCandidateStatsArgs = {
  input: CandidateStatsInput;
};


export type MutationUpdateWaitListStatusArgs = {
  onWaitList: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationVerifyAndCreateUserArgs = {
  autoInvite?: InputMaybe<Scalars['Boolean']['input']>;
  inviteCode: InputMaybe<Scalars['String']['input']>;
  locale?: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  otpId: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  referralUserId: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyAndCreateUserV2Args = {
  locale?: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  otpId: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};


export type MutationWaitingListArgs = {
  city: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
};


export type MutationWhitelistPhoneNumberArgs = {
  input: WhitelistPhoneNumberInput;
};


export type MutationWithinSupportedRegionArgs = {
  city: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
};

export type NotificationOptionInput = {
  allowed: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type NotificationOptionModel = {
  __typename?: 'NotificationOptionModel';
  allowed: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type OtpRequestModel = {
  __typename?: 'OtpRequestModel';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type PaginatedAbstractMatchModelCursorResponse = {
  __typename?: 'PaginatedAbstractMatchModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<AbstractMatchModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAnswerModelCursorResponse = {
  __typename?: 'PaginatedAnswerModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<AnswerModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAuditlogModelResponse = {
  __typename?: 'PaginatedAuditlogModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<AuditlogModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedChatGameModelCursorResponse = {
  __typename?: 'PaginatedChatGameModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<ChatGameModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedChatModelResponse = {
  __typename?: 'PaginatedChatModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<ChatModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedFriendSuggestionModelCursorResponse = {
  __typename?: 'PaginatedFriendSuggestionModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<FriendSuggestionModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedImageModelResponse = {
  __typename?: 'PaginatedImageModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<ImageModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedInstagramMediaModelCursorResponse = {
  __typename?: 'PaginatedInstagramMediaModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<InstagramMediaModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedMessageModelResponse = {
  __typename?: 'PaginatedMessageModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<MessageModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPhotoTestModelResponse = {
  __typename?: 'PaginatedPhotoTestModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<PhotoTestModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPlaceModelResponse = {
  __typename?: 'PaginatedPlaceModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<PlaceModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPlaceSuggestionModelResponse = {
  __typename?: 'PaginatedPlaceSuggestionModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<PlaceSuggestionModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedProfileModelResponse = {
  __typename?: 'PaginatedProfileModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<ProfileModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedProfileReactionModelCursorResponse = {
  __typename?: 'PaginatedProfileReactionModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<ProfileReactionModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPromptModelCursorResponse = {
  __typename?: 'PaginatedPromptModelCursorResponse';
  cursor: Maybe<Scalars['String']['output']>;
  items: Array<PromptModel>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PaginatedPromptModelResponse = {
  __typename?: 'PaginatedPromptModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<PromptModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedReportModelResponse = {
  __typename?: 'PaginatedReportModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<ReportModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PaginatedReportedProfileModelResponse = {
  __typename?: 'PaginatedReportedProfileModelResponse';
  hasMore: Maybe<Scalars['Boolean']['output']>;
  items: Array<ReportedProfileModel>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PhoneNumberInviteModel = {
  __typename?: 'PhoneNumberInviteModel';
  commonFriends: Scalars['Float']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  inviteCode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberScore: Maybe<Scalars['Float']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
};

export type PhotoTestImageModel = {
  __typename?: 'PhotoTestImageModel';
  createdAt: Scalars['DateTime']['output'];
  image: Maybe<ImageModel>;
  score: Maybe<Scalars['Float']['output']>;
};

export type PhotoTestModel = {
  __typename?: 'PhotoTestModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Maybe<Array<PhotoTestImageModel>>;
  progress: Maybe<Scalars['Float']['output']>;
  status: PhotoTestStatus;
};

export enum PhotoTestStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  REVEALED = 'REVEALED'
}

export type PlaceDistanceModel = {
  __typename?: 'PlaceDistanceModel';
  distance: Scalars['Float']['output'];
  place: PlaceModel;
};

export type PlaceModel = {
  __typename?: 'PlaceModel';
  address: AutoCompleteAddressModel;
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<ImageModel>;
  name: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  statistics: Maybe<PlaceStatisticModel>;
};

export type PlaceStatisticModel = {
  __typename?: 'PlaceStatisticModel';
  recommendedCount: Maybe<Scalars['Float']['output']>;
};

export type PlaceSuggestionInput = {
  text: Scalars['String']['input'];
};

export type PlaceSuggestionModel = {
  __typename?: 'PlaceSuggestionModel';
  cleanName: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Ids of other suggestions matching this place suggestion */
  ids: Array<Scalars['String']['output']>;
  latestSuggestedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  profiles: Array<ProfileModel>;
  userIds: Array<Scalars['String']['output']>;
};

export type PointModel = {
  __typename?: 'PointModel';
  coordinates: Array<Scalars['Float']['output']>;
};

export type PollGameModel = {
  __typename?: 'PollGameModel';
  compliments: Array<ComplimentModel>;
  complimentsPerDay: Scalars['Float']['output'];
  users: Array<PollUserModel>;
};

export type PollUserData = {
  id: Scalars['String']['input'];
  relation: PollUserRelation;
};

export type PollUserModel = {
  __typename?: 'PollUserModel';
  avatar: Maybe<ImageModel>;
  description: Scalars['String']['output'];
  hasAnyCompliments: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  relation: Scalars['String']['output'];
  relevantCompliments: Array<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
};

export type PolygonModel = {
  __typename?: 'PolygonModel';
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>;
};

export type PotentialDoubbleMatchesWithModel = {
  __typename?: 'PotentialDoubbleMatchesWithModel';
  friend: ProfileModel;
  /** The matches of the friend that may result in a DoubbleMatch. (If querying user matches the queried profile) */
  matches: Array<ProfileModel>;
};

export type ProfileComplimentModel = {
  __typename?: 'ProfileComplimentModel';
  compliment: Maybe<ComplimentModel>;
  complimentId: Maybe<Scalars['String']['output']>;
  complimented: Maybe<ProfileModel>;
  complimentedUserId: Maybe<Scalars['String']['output']>;
  complimenter: Maybe<ProfileModel>;
  complimenterId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  liked: Maybe<Scalars['Boolean']['output']>;
  seenAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileContactInformationInput = {
  birthDate: InputMaybe<Scalars['String']['input']>;
  company: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  hasEmail: InputMaybe<Scalars['Boolean']['input']>;
  hasPhoto: InputMaybe<Scalars['Boolean']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  referenceId: InputMaybe<Scalars['String']['input']>;
};

export type ProfileImageReactionInput = {
  imageId: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  /** Null intends to remove an existing reaction */
  reaction: InputMaybe<Scalars['String']['input']>;
};

export type ProfileInfoInput = {
  algorithm: InputMaybe<Scalars['Float']['input']>;
  bio: InputMaybe<Scalars['String']['input']>;
  birthDate: InputMaybe<Scalars['DateTime']['input']>;
  city: InputMaybe<AutoCompleteAddressInput>;
  compliments: InputMaybe<Array<Scalars['String']['input']>>;
  email: InputMaybe<Scalars['String']['input']>;
  gender: InputMaybe<Gender>;
  height: InputMaybe<Scalars['Int']['input']>;
  inboxPreference: InputMaybe<InboxPreference>;
  incognito: InputMaybe<Scalars['Boolean']['input']>;
  interests: InputMaybe<Array<Scalars['String']['input']>>;
  language: InputMaybe<Locales>;
  matchingActive: InputMaybe<Scalars['Boolean']['input']>;
  maxSuggestionAge: InputMaybe<Scalars['Int']['input']>;
  maxSuggestionDistance: InputMaybe<Scalars['Float']['input']>;
  minSuggestionAge: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  occupation: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  profileImageUrls: InputMaybe<Array<Scalars['String']['input']>>;
  public: InputMaybe<Scalars['Boolean']['input']>;
  school: InputMaybe<Scalars['String']['input']>;
  sexualOrientations: InputMaybe<Array<Gender>>;
  strictAgeRange: InputMaybe<Scalars['Boolean']['input']>;
  strictDistance: InputMaybe<Scalars['Boolean']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};

export type ProfileLocationModel = {
  __typename?: 'ProfileLocationModel';
  c: Array<Scalars['Float']['output']>;
  g: Maybe<Scalars['String']['output']>;
  h: Scalars['Float']['output'];
};

export type ProfileModel = {
  __typename?: 'ProfileModel';
  appFeatures: Array<AppFeature>;
  appVersion: Scalars['String']['output'];
  area: Maybe<Scalars['String']['output']>;
  avatar: Maybe<ImageModel>;
  bio: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['DateTime']['output']>;
  causedByBoost: Maybe<Scalars['Boolean']['output']>;
  cell: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  commonTeamMatesCount: Scalars['Float']['output'];
  compliments: Array<ProfileComplimentModel>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  devicePlatform: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  distance: Maybe<Scalars['Float']['output']>;
  /** @deprecated Fetch from doubble-match resolver instead */
  doubbleMatches: Array<DoubbleMatchModel>;
  email: Maybe<Scalars['String']['output']>;
  friendChatId: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  hasLocation: Scalars['Boolean']['output'];
  /** @deprecated Use appFeatures instead */
  hasPaywall: Scalars['Boolean']['output'];
  height: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  images: Array<ImageModel>;
  inContacts: Scalars['Boolean']['output'];
  inboxPreference: Maybe<InboxPreference>;
  incognito: Maybe<Scalars['Boolean']['output']>;
  interests: Array<InterestModel>;
  ipAddress: Scalars['String']['output'];
  isCommonTeamMate: Scalars['Boolean']['output'];
  language: Maybe<Scalars['String']['output']>;
  lastActive: Maybe<Scalars['DateTime']['output']>;
  logs: Array<UserLogModel>;
  matchChatId: Maybe<Scalars['String']['output']>;
  matchingActive: Maybe<Scalars['Boolean']['output']>;
  maxSuggestionAge: Maybe<Scalars['Int']['output']>;
  maxSuggestionDistance: Maybe<Scalars['Float']['output']>;
  minSuggestionAge: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** Fetches amount of matches _together_ with this profile. TOD: When querying self, instead of returning 0, you could fetch amount of matches you have with "yourself" */
  numberOfMatches: Scalars['Float']['output'];
  numberOfTeammates: Maybe<Scalars['Float']['output']>;
  occupation: Maybe<Scalars['String']['output']>;
  onWaitlist: Scalars['Boolean']['output'];
  operatingSystem: Scalars['String']['output'];
  phoneExtension: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  potentialDoubbleMatches: Array<ProfileModel>;
  potentialDoubbleMatchesCount: Scalars['Float']['output'];
  potentialDoubbleMatchesWith: Array<PotentialDoubbleMatchesWithModel>;
  public: Scalars['Boolean']['output'];
  reports: Maybe<Array<ReportModel>>;
  school: Maybe<Scalars['String']['output']>;
  sexualOrientations: Maybe<Array<Scalars['String']['output']>>;
  strictAgeRange: Maybe<Scalars['Boolean']['output']>;
  strictDistance: Maybe<Scalars['Boolean']['output']>;
  supportVerificationHash: Maybe<Scalars['String']['output']>;
  suspension: Maybe<SuspensionModel>;
  suspensions: Array<SuspensionModel>;
  teamMates: Array<ProfileModel>;
  tonightGroupId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use id instead */
  userId: Maybe<Scalars['ID']['output']>;
  userRegion: Maybe<Region>;
  username: Maybe<Scalars['String']['output']>;
  warnings: Maybe<Array<ProfileWarningModel>>;
  withinSupportedRegion: Scalars['Boolean']['output'];
};


export type ProfileModelDoubbleMatchesArgs = {
  useTTQ?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileModelPotentialDoubbleMatchesArgs = {
  useTTQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileReactionModel = {
  __typename?: 'ProfileReactionModel';
  createdAt: Scalars['DateTime']['output'];
  reactingUser: ProfileModel;
  reaction: Scalars['String']['output'];
};

export type ProfileReactionSummary = {
  __typename?: 'ProfileReactionSummary';
  imageId: Scalars['String']['output'];
  reactionCount: Scalars['Float']['output'];
  topReactions: Array<Scalars['String']['output']>;
};

export type ProfileWarningModel = {
  __typename?: 'ProfileWarningModel';
  callerId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  reason: Maybe<Scalars['String']['output']>;
  userSeen: Scalars['Boolean']['output'];
};

export type PromptConstraintModel = {
  __typename?: 'PromptConstraintModel';
  endTime: Maybe<Scalars['DateTime']['output']>;
  limit: Maybe<Scalars['Float']['output']>;
  searchTag: Maybe<Scalars['String']['output']>;
  specificLibrary: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['DateTime']['output']>;
};

export type PromptModel = {
  __typename?: 'PromptModel';
  chatTypes: Maybe<Array<ChatType>>;
  constraints: Maybe<PromptConstraintModel>;
  content: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  locale: Maybe<Locales>;
  prefillType: TagPrefillType;
};

export type PublicTonightMemberModel = {
  __typename?: 'PublicTonightMemberModel';
  imagePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeBoost: Maybe<BoostModel>;
  adminGeocode: Array<AutoCompleteAddressModel>;
  adminGetUser: ProfileModel;
  aegisReports: Array<AegisReportModel>;
  ageDistribution: Array<AgeDistributionModel>;
  albumPreferrenceWeights: Array<AlbumInfo>;
  allRedisConfigs: Array<Scalars['String']['output']>;
  /** @deprecated For old admin */
  allReports: PaginatedReportModelResponse;
  answers: PaginatedAnswerModelCursorResponse;
  appInfo: AppInfoModel;
  auditlogs: PaginatedAuditlogModelResponse;
  averageTeammatesPrUser: Scalars['Float']['output'];
  canChangeProfileField: Scalars['Boolean']['output'];
  canSeeComplimentsUntil: Maybe<Scalars['DateTime']['output']>;
  candidatesByIds: Array<CandidateModel>;
  chat: ChatModel;
  chatGameById: ChatGameModel;
  chatGames: PaginatedChatGameModelCursorResponse;
  chatMessageSuggestions: Array<Scalars['String']['output']>;
  chatRequests: PaginatedChatModelResponse;
  chatsV3: PaginatedChatModelResponse;
  consumableItem: ConsumableItemModel;
  consumableItems: Array<ConsumableItemModel>;
  currentBoost: Maybe<BoostModel>;
  currentProfile: ProfileModel;
  doubbleMatchDistribution: Array<DoubbleMatchDistributionModel>;
  doubbleMatches: Array<DoubbleMatchModel>;
  doubbleMatchesCount: Scalars['Float']['output'];
  emailInUse: Scalars['Boolean']['output'];
  expiringDoubbleMatches: ExpiringDoubbleMatchesModel;
  exploreTonightGroups: Array<TonightGroupModel>;
  friendSuggestions: PaginatedFriendSuggestionModelCursorResponse;
  genderDistribution: Array<GenderDistributionModel>;
  geocode: Array<AutoCompleteAddressModel>;
  getCloudflareAUD: Array<Scalars['String']['output']>;
  getInvitationDetails: Array<PublicTonightMemberModel>;
  getReportedChat: ReportedChatModel;
  getTonightSessionStatus: TonightSessionModel;
  getUnlockableDoubbleMatch: Maybe<DoubbleMatchModel>;
  /** Returns how many people are active in tonight in the current session */
  globalTonightActiveCount: Scalars['Int']['output'];
  guessGender: Maybe<Gender>;
  guessName: Maybe<Scalars['String']['output']>;
  imagesForPhotoTest: Array<ImageModel>;
  instagramPhotos: PaginatedInstagramMediaModelCursorResponse;
  interests: Array<InterestModel>;
  invite: InviteModel;
  inviteCode: InviteCodeModel;
  inviteData: InvitesDataModel;
  inviteableContacts: Array<PhoneNumberInviteModel>;
  invitedContacts: Array<PhoneNumberInviteModel>;
  invitedProfileIds: Array<Scalars['String']['output']>;
  invitedProfiles: Array<ProfileModel>;
  invitingProfiles: Array<ProfileModel>;
  isSubscribedToTonight: Scalars['Boolean']['output'];
  lastSwipeDate: Maybe<Scalars['DateTime']['output']>;
  likedMe: Array<LikedMeModel>;
  likedMeCount: Scalars['Int']['output'];
  likesAndDislikesCount: LikesAndDislikesModel;
  matches: Array<MatchModel>;
  matchesNotPartOfDoubbleMatchCount: Scalars['Float']['output'];
  matchesV2: PaginatedAbstractMatchModelCursorResponse;
  messages: PaginatedMessageModelResponse;
  myCompliments: Array<ProfileComplimentModel>;
  myTonightGroup: Maybe<TonightGroupModel>;
  myTopCompliments: Array<ComplimentModel>;
  /** Warnings that the user have not yet seen */
  nonSeenWarnings: Array<ProfileWarningModel>;
  notificationOptions: Array<NotificationOptionModel>;
  onWaitlist: Scalars['Boolean']['output'];
  oneSidedLikes: Scalars['Float']['output'];
  paginatedImagesForPhotoTest: PaginatedImageModelResponse;
  paginatedPrompts: PaginatedPromptModelResponse;
  photoTest: PhotoTestModel;
  photoTests: PaginatedPhotoTestModelResponse;
  placeSuggestions: PaginatedPlaceSuggestionModelResponse;
  places: Array<PlaceDistanceModel>;
  placesWithoutDistance: PaginatedPlaceModelResponse;
  pollGame: PollGameModel;
  potentialDoubbleMatchesWith: Array<PotentialDoubbleMatchesWithModel>;
  profile: ProfileModel;
  profileCompliment: ProfileComplimentModel;
  profileContacts: UserContactsModel;
  profileLocations: Array<ProfileLocationModel>;
  profileReactions: PaginatedProfileReactionModelCursorResponse;
  profiles: PaginatedProfileModelResponse;
  profilesThroughContacts: Array<ProfileModel>;
  promptInAllLocales: Array<PromptModel>;
  promptSuggestions: Array<PromptModel>;
  promptsByType: PaginatedPromptModelCursorResponse;
  recentlyLiked: Array<ProfileModel>;
  recommendedCandidates: Array<CandidateModel>;
  reportedProfiles: PaginatedReportedProfileModelResponse;
  searchUser: Array<ProfileModel>;
  searchUsers: PaginatedProfileModelResponse;
  shuffledPrompt: PaginatedPromptModelCursorResponse;
  stockProfiles: Array<ProfileModel>;
  subscriptionStatus: Scalars['Boolean']['output'];
  supportedRegions: Array<SupportedRegionModel>;
  swipeDeck: SwipeDeckModel;
  teammates: Array<ProfileModel>;
  teammatesDistribution: Array<TeammatesDistributionModel>;
  tokenEntitlements: Array<PremiumEntitlement>;
  tonightChatContext: Maybe<TonightChatContextModel>;
  tonightGroupById: TonightGroupModel;
  /** Get all active tonight group invites for the current user. Excluding those already accepted. */
  tonightGroupInvites: Array<TonightGroupInviteModel>;
  topLockedMatches: Array<ProfileModel>;
  totalDoubbleMatchesCount: Scalars['Float']['output'];
  totalMatchesCount: Scalars['Float']['output'];
  totalProfileCount: Scalars['Float']['output'];
  trueUsers: Array<TrueUserModel>;
  unreadChatCount: Scalars['Float']['output'];
  /** @deprecated Use unreadChatCount instead */
  unreadChatCountV2: Scalars['Float']['output'];
  unseenCompliments: Scalars['Float']['output'];
  usernameInUse: Scalars['Boolean']['output'];
  /** @deprecated Use searchUser instead */
  usernameSearch: Array<UsernameSearchModel>;
  usernameSuggestions: Array<Scalars['String']['output']>;
  versionedRouteGuards: Array<VersionedRouteGuardModel>;
  waitingListArea: Maybe<Scalars['String']['output']>;
  whoAdminI: AdminModel;
  whosTyping: Array<Scalars['String']['output']>;
};


export type QueryAdminGeocodeArgs = {
  onlyCities?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAdminGetUserArgs = {
  profileId: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type QueryAegisReportsArgs = {
  blocked: InputMaybe<Scalars['Boolean']['input']>;
  ip: InputMaybe<Scalars['String']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
  used: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllReportsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAnswersArgs = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryAuditlogsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryCanChangeProfileFieldArgs = {
  input: CanChangeProfileFieldArg;
};


export type QueryCandidatesByIdsArgs = {
  candidateIds: Array<Scalars['String']['input']>;
  sharedById: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryChatGameByIdArgs = {
  chatId: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};


export type QueryChatGamesArgs = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
  unanswered: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatMessageSuggestionsArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryChatRequestsArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  ignored: Scalars['Boolean']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryChatsV3Args = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  expiringSoon?: Scalars['Boolean']['input'];
  filter: InputMaybe<Filter>;
  matchId: InputMaybe<Scalars['String']['input']>;
  query?: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
  teamMateId: InputMaybe<Scalars['String']['input']>;
  withoutMessages?: Scalars['Boolean']['input'];
};


export type QueryConsumableItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsumableItemsArgs = {
  type: InputMaybe<ConsumableItemType>;
};


export type QueryDoubbleMatchesArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  filter: InputMaybe<Filter>;
  groupByMatch?: Scalars['Boolean']['input'];
  matchId: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
  teamMateId: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailInUseArgs = {
  email: Scalars['String']['input'];
};


export type QueryExploreTonightGroupsArgs = {
  ignoreGroups: InputMaybe<Array<Scalars['String']['input']>>;
  take: Scalars['Int']['input'];
};


export type QueryFriendSuggestionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<FriendSuggestionsCategory>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryGeocodeArgs = {
  onlyCities?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryGetCloudflareAudArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetInvitationDetailsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetReportedChatArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryGetUnlockableDoubbleMatchArgs = {
  ignoreSuggestions?: Array<Scalars['String']['input']>;
};


export type QueryGuessGenderArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type QueryGuessNameArgs = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstagramPhotosArgs = {
  cursor: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryInviteArgs = {
  inviteCode: Scalars['String']['input'];
};


export type QueryInviteCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryInviteableContactsArgs = {
  page?: Scalars['Float']['input'];
  startCursor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLikedMeArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  filter: InputMaybe<Filter>;
  since: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
  type: InputMaybe<LikedMeType>;
};


export type QueryLikedMeCountArgs = {
  filter: InputMaybe<Filter>;
  since: InputMaybe<Scalars['DateTime']['input']>;
  type: InputMaybe<LikedMeType>;
};


export type QueryMatchesArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  filter: InputMaybe<Filter>;
  take?: Scalars['Int']['input'];
};


export type QueryMatchesV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<MatchesFilterInput>;
  groupBy: InputMaybe<MatchesGroupByInput>;
  take?: Scalars['Int']['input'];
};


export type QueryMessagesArgs = {
  chatId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryMyComplimentsArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryNotificationOptionsArgs = {
  token: Scalars['String']['input'];
};


export type QueryOnWaitlistArgs = {
  city: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaginatedImagesForPhotoTestArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryPaginatedPromptsArgs = {
  chatType: InputMaybe<Scalars['String']['input']>;
  gameType: InputMaybe<Scalars['String']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryPhotoTestArgs = {
  photoTestId: Scalars['String']['input'];
};


export type QueryPhotoTestsArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryPlaceSuggestionsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryPlacesArgs = {
  cursor?: Scalars['Int']['input'];
  maxDistance?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryPlacesWithoutDistanceArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryPollGameArgs = {
  ttq?: Scalars['Boolean']['input'];
};


export type QueryPotentialDoubbleMatchesWithArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryProfileArgs = {
  userId: InputMaybe<Scalars['String']['input']>;
};


export type QueryProfileComplimentArgs = {
  complimentId: Scalars['String']['input'];
  complimenterUserId: Scalars['String']['input'];
};


export type QueryProfileLocationsArgs = {
  page: Scalars['Float']['input'];
};


export type QueryProfileReactionsArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  imageId: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryProfilesArgs = {
  onlyWaitListed?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryPromptInAllLocalesArgs = {
  promptId: Scalars['String']['input'];
};


export type QueryPromptSuggestionsArgs = {
  chatTypes?: InputMaybe<Array<ChatType>>;
  personalized?: Scalars['Boolean']['input'];
};


export type QueryPromptsByTypeArgs = {
  chatTypes?: InputMaybe<Array<ChatType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
  type: GameType;
};


export type QueryRecentlyLikedArgs = {
  take: InputMaybe<Scalars['Float']['input']>;
};


export type QueryRecommendedCandidatesArgs = {
  fromInviteCode: InputMaybe<Scalars['String']['input']>;
  specificCandidate: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportedProfilesArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QuerySearchUserArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUsersArgs = {
  query: Scalars['String']['input'];
};


export type QueryShuffledPromptArgs = {
  chatTypes?: InputMaybe<Array<ChatType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
  type: GameType;
};


export type QueryStockProfilesArgs = {
  take: Scalars['Float']['input'];
};


export type QuerySwipeDeckArgs = {
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: InputMaybe<Filter>;
  preferStale?: Scalars['Boolean']['input'];
  swipeCount?: InputMaybe<Scalars['Int']['input']>;
  take?: Scalars['Int']['input'];
  ttq?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTeammatesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTonightChatContextArgs = {
  groupId: Scalars['String']['input'];
  otherGroupId: Scalars['String']['input'];
};


export type QueryTonightGroupByIdArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryTrueUsersArgs = {
  usernames?: Scalars['String']['input'];
};


export type QueryUsernameInUseArgs = {
  username: Scalars['String']['input'];
};


export type QueryUsernameSearchArgs = {
  searchString: Scalars['String']['input'];
};


export type QueryUsernameSuggestionsArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
};


export type QueryWhosTypingArgs = {
  chatId: Scalars['String']['input'];
};

export type RefreshAuthTokensInput = {
  refreshToken: Scalars['String']['input'];
};

export type ReplyToGameAnswerInput = {
  chatId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  repliedMessageId: Scalars['String']['input'];
};

export type ReplyToGameAnswerInputV2 = {
  chatId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};

export type ReplyToGameInput = {
  chatId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
};

export type ReportInput = {
  message: InputMaybe<Scalars['String']['input']>;
  offendingElementId: Scalars['String']['input'];
  type: ReportType;
};

export type ReportModel = {
  __typename?: 'ReportModel';
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  creatorOfReportedContentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Maybe<Scalars['String']['output']>;
  reportedElementId: Scalars['String']['output'];
  reporter: Maybe<ProfileModel>;
  reportingUserId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ReportType {
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  DATING_PROFILE = 'DATING_PROFILE',
  PROFILE = 'PROFILE',
  TONIGHT_GROUP = 'TONIGHT_GROUP'
}

export type ReportedChatModel = {
  __typename?: 'ReportedChatModel';
  chat: ChatModel;
  messages: Array<MessageModel>;
  profiles: Array<ProfileModel>;
};

export type ReportedProfileModel = {
  __typename?: 'ReportedProfileModel';
  count: Scalars['Float']['output'];
  lastReportedAt: Scalars['DateTime']['output'];
  profile: ProfileModel;
  reports: Array<ReportModel>;
  reportsSinceWarning: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type RevokeSuspensionInput = {
  suspensionId: Scalars['String']['input'];
};

export type SaveDeviceInfoArgs = {
  data: Scalars['JSON']['input'];
};

export type SavePromptInput = {
  chatTypes: Array<ChatType>;
  constraints: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  gameType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  locale: Locales;
  tagPrefillType: TagPrefillType;
};

export type SendMessageInput = {
  chatId: Scalars['String']['input'];
  contextId: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  messageRepliedToId: InputMaybe<Scalars['String']['input']>;
};

export type ShareProfileInput = {
  createUnlockAttemptMessage: InputMaybe<Scalars['Boolean']['input']>;
  matchId: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type StartChatGameInput = {
  chatId: Scalars['String']['input'];
  customPrompt: InputMaybe<Scalars['String']['input']>;
  promptId: Scalars['String']['input'];
};

export type StartPhotoTestInput = {
  imageUrls: Array<Scalars['String']['input']>;
};

export type SubmitAnswerInput = {
  chatId: Scalars['String']['input'];
  confessed: InputMaybe<Scalars['Boolean']['input']>;
  flag: InputMaybe<Scalars['Boolean']['input']>;
  gameId: Scalars['String']['input'];
  gameType: GameType;
  imageData: InputMaybe<Scalars['String']['input']>;
  rating: InputMaybe<Scalars['Float']['input']>;
  shuffled: InputMaybe<Scalars['Float']['input']>;
  taggedUserId: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};

export type SubmitSingleAnswersInput = {
  customPrompt: InputMaybe<Scalars['String']['input']>;
  gameType: GameType;
  promptId: Scalars['String']['input'];
  /** Chat ID to explicitly unhide the answers for, e.g. sending answers from one chat into another */
  unhideChatId: InputMaybe<Scalars['String']['input']>;
  user1Id: InputMaybe<Scalars['String']['input']>;
  user2Id: InputMaybe<Scalars['String']['input']>;
  userIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  subscribeToAppEvents: Maybe<AppEventModel>;
  subscribeToChats: Maybe<ChatStreamEventModel>;
};


export type SubscriptionSubscribeToChatsArgs = {
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupportedAreaModel = {
  __typename?: 'SupportedAreaModel';
  count: AreaPopulationModel;
  launched: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  polygon: PolygonModel;
  target: Maybe<Scalars['Float']['output']>;
};

export type SupportedRegionModel = {
  __typename?: 'SupportedRegionModel';
  areas: Array<SupportedAreaModel>;
  code: Scalars['String']['output'];
  launched: Scalars['Boolean']['output'];
  polygon: PolygonModel;
  target: Maybe<Scalars['Float']['output']>;
};

export type SuspensionInput = {
  permanent: Scalars['Boolean']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  until: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type SuspensionModel = {
  __typename?: 'SuspensionModel';
  createdAt: Scalars['DateTime']['output'];
  duration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permanent: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  reason: Maybe<Scalars['String']['output']>;
  until: Maybe<Scalars['DateTime']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type SwipeDeckModel = {
  __typename?: 'SwipeDeckModel';
  appliedFilter: Maybe<Filter>;
  candidates: Array<CandidateModel>;
  hasMore: Scalars['Boolean']['output'];
  isStale: Scalars['Boolean']['output'];
  location: Maybe<PointModel>;
};

export type SwipeModel = {
  __typename?: 'SwipeModel';
  /** @deprecated deprecated */
  activeAfter: Maybe<Scalars['String']['output']>;
  doubbleMatches: Array<DoubbleMatchModel>;
  id: Maybe<Scalars['String']['output']>;
  like: Scalars['Boolean']['output'];
  /** @deprecated deprecated */
  likedId: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated */
  liker: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated */
  likerId: Maybe<Scalars['String']['output']>;
  match: Maybe<ProfileModel>;
  swipedUserId: Scalars['String']['output'];
  swiperUserId: Scalars['String']['output'];
  /** @deprecated deprecated */
  verdict: Maybe<Scalars['String']['output']>;
};

export type SwipedProfileAttachmentModel = {
  __typename?: 'SwipedProfileAttachmentModel';
  liked: Maybe<Scalars['Boolean']['output']>;
  messageId: Scalars['String']['output'];
};

export enum TagPrefillType {
  FRIEND = 'FRIEND',
  MATCH = 'MATCH',
  NONE = 'NONE'
}

export type TeammatesDistributionModel = {
  __typename?: 'TeammatesDistributionModel';
  count: Scalars['Float']['output'];
  teammates: Scalars['Float']['output'];
};

export type TestNotificationModel = {
  __typename?: 'TestNotificationModel';
  notification: Scalars['JSON']['output'];
  sentNotificationsCount: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TonightChatContextModel = {
  __typename?: 'TonightChatContextModel';
  initiator: ProfileModel;
  relatedProfile: Maybe<ProfileModel>;
  type: TonightChatContextType;
};

export enum TonightChatContextType {
  FRIEND = 'FRIEND',
  MATCH = 'MATCH'
}

export type TonightGroupInviteModel = {
  __typename?: 'TonightGroupInviteModel';
  createdAt: Scalars['DateTime']['output'];
  groupId: Scalars['ID']['output'];
  inviter: ProfileModel;
  members: Array<TonightGroupMemberModel>;
};

export type TonightGroupMemberModel = {
  __typename?: 'TonightGroupMemberModel';
  matched: Scalars['Boolean']['output'];
  /** The profile of the member, usually resolved using data loader */
  profile: ProfileModel;
  status: TonnightGroupMemberStatus;
};

export type TonightGroupModel = {
  __typename?: 'TonightGroupModel';
  chatId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastActive: Scalars['DateTime']['output'];
  /** Non-localized location of the group, established at creation time */
  location: Maybe<Scalars['String']['output']>;
  members: Array<TonightGroupMemberModel>;
  /** The related profile id, e.g. the user that was matched within the group */
  relatedProfileId: Maybe<Scalars['ID']['output']>;
  status: TonightSessionModel;
};

export type TonightSessionModel = {
  __typename?: 'TonightSessionModel';
  closesAt: Maybe<Scalars['DateTime']['output']>;
  opensAt: Maybe<Scalars['DateTime']['output']>;
  status: TonightSessionStatus;
};

export enum TonightSessionStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export enum TonnightGroupMemberStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING'
}

export type TrueUserModel = {
  __typename?: 'TrueUserModel';
  averageMessageSentPerChat: Scalars['Float']['output'];
  chatInteractions: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  doubbleMatchesCount: Scalars['Float']['output'];
  experiencesSuggested: Scalars['Float']['output'];
  friendsCount: Scalars['Float']['output'];
  hasBio: Scalars['Boolean']['output'];
  hasCity: Scalars['Boolean']['output'];
  hasOccupation: Scalars['Boolean']['output'];
  hasSchool: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interestsCount: Scalars['Float']['output'];
  lastActive: Maybe<Scalars['DateTime']['output']>;
  matchesCount: Scalars['Float']['output'];
  matchingActive: Scalars['Boolean']['output'];
  profileImagesCount: Scalars['Float']['output'];
  sentMessages: Scalars['Float']['output'];
  swipesCount: Scalars['Float']['output'];
  trueUser: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type UserContactInformationModel = {
  __typename?: 'UserContactInformationModel';
  hasPhoto: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberScore: Scalars['Float']['output'];
  referenceId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UserContactsModel = {
  __typename?: 'UserContactsModel';
  contacts: Array<UserContactInformationModel>;
  profileId: Scalars['ID']['output'];
};

export type UserFeedbackInput = {
  description: InputMaybe<Scalars['String']['input']>;
  reasons: InputMaybe<Array<Scalars['String']['input']>>;
  type: InputMaybe<FeedbackType>;
};

export type UserLogModel = {
  __typename?: 'UserLogModel';
  action: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export type UserModel = {
  __typename?: 'UserModel';
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type UsernameSearchModel = {
  __typename?: 'UsernameSearchModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type VersionedRouteGuardModel = {
  __typename?: 'VersionedRouteGuardModel';
  minimumVersion: Scalars['Float']['output'];
  routeName: Scalars['String']['output'];
};

export type WhitelistPhoneNumberInput = {
  description: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export enum AppFeature {
  BOOST = 'BOOST',
  CHAT_LINKS = 'CHAT_LINKS',
  COMPLIMENT_REACTIONS = 'COMPLIMENT_REACTIONS',
  INSTAGRAM_IMAGE_PICKER = 'INSTAGRAM_IMAGE_PICKER',
  MY_TYPE_FILTER = 'MY_TYPE_FILTER',
  PAYWALL = 'PAYWALL',
  PHOTO_TEST = 'PHOTO_TEST',
  READ_RECEIPTS = 'READ_RECEIPTS',
  SEGMENTED_CHAT_CONTROLS = 'SEGMENTED_CHAT_CONTROLS',
  SWR = 'SWR'
}

export enum CandidateStatsType {
  PROFILE_CARD = 'PROFILE_CARD',
  SWIPE_DECK = 'SWIPE_DECK',
  UNLOCK_DOUBBLE_MATCH = 'UNLOCK_DOUBBLE_MATCH'
}

export enum ChatUserStatus {
  ACCEPTED = 'ACCEPTED',
  IGNORED = 'IGNORED',
  PENDING = 'PENDING'
}

export enum ComplimentType {
  FUN_WITH_FRIENDS = 'FUN_WITH_FRIENDS',
  MORE_FRIENDS = 'MORE_FRIENDS'
}

export enum ConsumableItemTrigger {
  GIFT = 'GIFT',
  PURCHASE = 'PURCHASE',
  PURCHASE_BONUS = 'PURCHASE_BONUS',
  REWARD = 'REWARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export enum ConsumableItemType {
  BOOST = 'BOOST',
  GIFTABLE_JOINABLE_BOOST = 'GIFTABLE_JOINABLE_BOOST',
  JOINABLE_BOOST = 'JOINABLE_BOOST',
  MATCH_CHAT_UNLOCK = 'MATCH_CHAT_UNLOCK',
  PHOTO_TEST = 'PHOTO_TEST',
  PRIORITY_MESSAGE = 'PRIORITY_MESSAGE',
  SUPER_COMPLIMENT = 'SUPER_COMPLIMENT'
}

export enum Filter {
  ACTIVE_TODAY = 'ACTIVE_TODAY',
  FOR_YOU = 'FOR_YOU',
  LONER = 'LONER',
  MY_TYPE = 'MY_TYPE',
  NEARBY = 'NEARBY',
  NEWBIE = 'NEWBIE',
  TONIGHT = 'TONIGHT'
}

export enum FriendSuggestionsCategory {
  CONTACT = 'CONTACT',
  PROFILE = 'PROFILE'
}

export enum Gender {
  FEMALE = 'FEMALE',
  Female = 'Female',
  MALE = 'MALE',
  Male = 'Male',
  NON_BINARY = 'NON_BINARY',
  NonBinary = 'NonBinary'
}

export enum InboxPreference {
  DIRECT = 'DIRECT',
  REQUEST = 'REQUEST'
}

export enum InviteResponse {
  Accept = 'Accept',
  Reject = 'Reject'
}

export enum LikedMeType {
  ALL = 'ALL',
  DISLIKED = 'DISLIKED',
  NEW = 'NEW'
}

export enum Locales {
  DA = 'DA',
  EN = 'EN',
  NL = 'NL',
  NO = 'NO',
  SV = 'SV',
  da = 'da',
  en = 'en',
  nl = 'nl',
  no = 'no',
  sv = 'sv'
}

export enum MatchType {
  DOUBBLE_MATCH = 'DOUBBLE_MATCH',
  MATCH = 'MATCH'
}

export enum MessageAttachmentKind {
  AUDIO = 'AUDIO',
  COMPLIMENT = 'COMPLIMENT',
  CONTEXT = 'CONTEXT',
  FILE = 'FILE',
  GAME_ANSWER_REPLY = 'GAME_ANSWER_REPLY',
  GAME_REPLY = 'GAME_REPLY',
  GIF = 'GIF',
  IMAGE = 'IMAGE',
  PROFILE = 'PROFILE',
  PROFILE_SWIPE = 'PROFILE_SWIPE',
  REACTION = 'REACTION',
  REPLY = 'REPLY',
  VIDEO = 'VIDEO'
}

export enum PollUserRelation {
  FRIEND = 'FRIEND',
  FRIEND_SUGGESTION = 'FRIEND_SUGGESTION',
  INVITEABLE_CONTACT = 'INVITEABLE_CONTACT'
}

export enum PremiumEntitlement {
  FILTERS = 'FILTERS',
  INCOGNITO = 'INCOGNITO',
  LIKED_ME = 'LIKED_ME',
  MATCH_CHAT = 'MATCH_CHAT',
  PRIORITY_LIKES = 'PRIORITY_LIKES',
  READ_RECEIPTS = 'READ_RECEIPTS',
  UNDO = 'UNDO',
  UNLIMITED_LIKES = 'UNLIMITED_LIKES',
  WEEKLY_FREE_BOOST = 'WEEKLY_FREE_BOOST',
  WEEKLY_FREE_PHOTO_TEST = 'WEEKLY_FREE_PHOTO_TEST'
}

export enum Region {
  EUROPE_WEST = 'EUROPE_WEST',
  US_EAST = 'US_EAST',
  US_WEST = 'US_WEST'
}

export enum RestrictedProfileField {
  BIRTH_DATE = 'BIRTH_DATE',
  GENDER = 'GENDER',
  NAME = 'NAME'
}

export enum SpacetimeFilter {
  ACTIVE_TODAY = 'ACTIVE_TODAY',
  NEARBY = 'NEARBY'
}

export type GetInvitationDetailsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetInvitationDetailsQuery = { __typename?: 'Query', getInvitationDetails: Array<{ __typename?: 'PublicTonightMemberModel', userId: string, name: string, imagePath: string }> };


export const GetInvitationDetailsDocument = gql`
    query GetInvitationDetails($groupId: String!) {
  getInvitationDetails(groupId: $groupId) {
    userId
    name
    imagePath
  }
}
    `;

/**
 * __useGetInvitationDetailsQuery__
 *
 * To run a query within a React component, call `useGetInvitationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationDetailsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInvitationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables> & ({ variables: GetInvitationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>(GetInvitationDetailsDocument, options);
      }
export function useGetInvitationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>(GetInvitationDetailsDocument, options);
        }
export function useGetInvitationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>(GetInvitationDetailsDocument, options);
        }
export type GetInvitationDetailsQueryHookResult = ReturnType<typeof useGetInvitationDetailsQuery>;
export type GetInvitationDetailsLazyQueryHookResult = ReturnType<typeof useGetInvitationDetailsLazyQuery>;
export type GetInvitationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetInvitationDetailsSuspenseQuery>;
export type GetInvitationDetailsQueryResult = Apollo.QueryResult<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>;
export function refetchGetInvitationDetailsQuery(variables: GetInvitationDetailsQueryVariables) {
      return { query: GetInvitationDetailsDocument, variables: variables }
    }